import {BaseService} from './baseService.js';

/**
 * Client service for user workspace save states (per user + company).
 */
export class WorkspaceService extends BaseService {

	async listWorkspaces() {
		return this.makeGETRequest('/api/resource/user-workspaces');
	}

	async getWorkspace(workspaceId) {
		return this.makeGETRequest('/api/resource/user-workspaces/' + workspaceId);
	}

	async saveWorkspace(workspace) {
		return this.makePOSTRequest('/api/resource/user-workspaces', workspace);
	}

	async updateWorkspace(workspaceId, workspace) {
		return this.makePUTRequest('/api/resource/user-workspaces/' + workspaceId, workspace);
	}

	async deleteWorkspace(workspaceId) {
		return this.makeDELETERequest('/api/resource/user-workspaces/' + workspaceId);
	}
}
